<template>
  <div class="container">
    <div>
      <div class="title">{{info.title}}</div>
      <div class="logos">
        <img v-for="(item,i) in info.logo" :src="item" :key="i"/>
      </div>
      <div class="p" v-if="info.progress<100">{{info.text1}}</div>
      <div class="p" v-else>{{info.text3}}</div>
      <template v-if="info.progress<100">
        <video :src="info.video" :poster="info.poster" controls></video>
        <div class="progress1">
          <span>当前进度<label>{{info.progress}}%</label></span>
          <label>更新于{{info.update_time}}</label>
        </div>
        <div class="progress">
          <div class="fill" :style="{width:info.progress+'%'}"></div>
        </div>
        <div class="p">{{info.text2}}</div>
        <div><a class="submit">{{info.button_text}}</a></div>
      </template>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        info: {}
      }
    },
    async mounted () {
      this.info = await this.$service.other.getPay()
    }
  }
</script>
<style scoped lang='scss'>
  .container {
    background-color: #ebf0f4;
    color: #414141;
    padding: 15px;
    > div {
      padding: 20px 20px 28px;
      background-color: white;
      border-radius: 6px;
    }
  }

  .title {
    text-align: center;
    font-size: 18px;
  }

  .logos {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    img {
      width: 37px;
      height: 37px;
      border-radius: 8px;
      box-shadow: 2px 2px 5px #dddddd;
      margin: 0 20px;
    }
  }

  video {
    width: 100%;
    height: 175px;
    margin: 5px 0;
  }

  .p {
    line-height: 1.5;
    font-size: 14px;
  }

  .progress1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px 0;
    font-size: 12px;
    label {
      color: #999999;
    }
  }

  .progress {
    border-radius: 100px;
    overflow: hidden;
    margin: 5px 0 25px;
    background-color: #e2e2e2;
    height: 8px;
    .fill {
      max-width: 100%;
      height: 100%;
      border-radius: 100px;
      background-color: #51aa38;
    }
  }

  .submit {
    display: block;
    margin-top: 40px;
    color: white;
    background-color: #51aa38;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?aed4b9ac